"use strict";

var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getLength = exports.decode = exports.encode = void 0;
var bn_js_1 = __importDefault(require("bn.js"));
/**
 * RLP Encoding based on: https://github.com/ethereum/wiki/wiki/%5BEnglish%5D-RLP
 * This function takes in a data, convert it to buffer if not, and a length for recursion
 * @param input - will be converted to buffer
 * @returns returns buffer of encoded data
 **/
function encode(input) {
  if (Array.isArray(input)) {
    var output = [];
    for (var i = 0; i < input.length; i++) {
      output.push(encode(input[i]));
    }
    var buf = Buffer.concat(output);
    return Buffer.concat([encodeLength(buf.length, 192), buf]);
  } else {
    var inputBuf = toBuffer(input);
    return inputBuf.length === 1 && inputBuf[0] < 128 ? inputBuf : Buffer.concat([encodeLength(inputBuf.length, 128), inputBuf]);
  }
}
exports.encode = encode;
/**
 * Parse integers. Check if there is no leading zeros
 * @param v The value to parse
 * @param base The base to parse the integer into
 */
function safeParseInt(v, base) {
  if (v[0] === '0' && v[1] === '0') {
    throw new Error('invalid RLP: extra zeros');
  }
  return parseInt(v, base);
}
function encodeLength(len, offset) {
  if (len < 56) {
    return Buffer.from([len + offset]);
  } else {
    var hexLength = intToHex(len);
    var lLength = hexLength.length / 2;
    var firstByte = intToHex(offset + 55 + lLength);
    return Buffer.from(firstByte + hexLength, 'hex');
  }
}
function decode(input, stream) {
  if (stream === void 0) {
    stream = false;
  }
  if (!input || input.length === 0) {
    return Buffer.from([]);
  }
  var inputBuffer = toBuffer(input);
  var decoded = _decode(inputBuffer);
  if (stream) {
    return decoded;
  }
  if (decoded.remainder.length !== 0) {
    throw new Error('invalid remainder');
  }
  return decoded.data;
}
exports.decode = decode;
/**
 * Get the length of the RLP input
 * @param input
 * @returns The length of the input or an empty Buffer if no input
 */
function getLength(input) {
  if (!input || input.length === 0) {
    return Buffer.from([]);
  }
  var inputBuffer = toBuffer(input);
  var firstByte = inputBuffer[0];
  if (firstByte <= 0x7f) {
    return inputBuffer.length;
  } else if (firstByte <= 0xb7) {
    return firstByte - 0x7f;
  } else if (firstByte <= 0xbf) {
    return firstByte - 0xb6;
  } else if (firstByte <= 0xf7) {
    // a list between  0-55 bytes long
    return firstByte - 0xbf;
  } else {
    // a list  over 55 bytes long
    var llength = firstByte - 0xf6;
    var length_1 = safeParseInt(inputBuffer.slice(1, llength).toString('hex'), 16);
    return llength + length_1;
  }
}
exports.getLength = getLength;
/** Decode an input with RLP */
function _decode(input) {
  var length, llength, data, innerRemainder, d;
  var decoded = [];
  var firstByte = input[0];
  if (firstByte <= 0x7f) {
    // a single byte whose value is in the [0x00, 0x7f] range, that byte is its own RLP encoding.
    return {
      data: input.slice(0, 1),
      remainder: input.slice(1)
    };
  } else if (firstByte <= 0xb7) {
    // string is 0-55 bytes long. A single byte with value 0x80 plus the length of the string followed by the string
    // The range of the first byte is [0x80, 0xb7]
    length = firstByte - 0x7f;
    // set 0x80 null to 0
    if (firstByte === 0x80) {
      data = Buffer.from([]);
    } else {
      data = input.slice(1, length);
    }
    if (length === 2 && data[0] < 0x80) {
      throw new Error('invalid rlp encoding: byte must be less 0x80');
    }
    return {
      data: data,
      remainder: input.slice(length)
    };
  } else if (firstByte <= 0xbf) {
    // string is greater than 55 bytes long. A single byte with the value (0xb7 plus the length of the length),
    // followed by the length, followed by the string
    llength = firstByte - 0xb6;
    if (input.length - 1 < llength) {
      throw new Error('invalid RLP: not enough bytes for string length');
    }
    length = safeParseInt(input.slice(1, llength).toString('hex'), 16);
    if (length <= 55) {
      throw new Error('invalid RLP: expected string length to be greater than 55');
    }
    data = input.slice(llength, length + llength);
    if (data.length < length) {
      throw new Error('invalid RLP: not enough bytes for string');
    }
    return {
      data: data,
      remainder: input.slice(length + llength)
    };
  } else if (firstByte <= 0xf7) {
    // a list between  0-55 bytes long
    length = firstByte - 0xbf;
    innerRemainder = input.slice(1, length);
    while (innerRemainder.length) {
      d = _decode(innerRemainder);
      decoded.push(d.data);
      innerRemainder = d.remainder;
    }
    return {
      data: decoded,
      remainder: input.slice(length)
    };
  } else {
    // a list  over 55 bytes long
    llength = firstByte - 0xf6;
    length = safeParseInt(input.slice(1, llength).toString('hex'), 16);
    var totalLength = llength + length;
    if (totalLength > input.length) {
      throw new Error('invalid rlp: total length is larger than the data');
    }
    innerRemainder = input.slice(llength, totalLength);
    if (innerRemainder.length === 0) {
      throw new Error('invalid rlp, List has a invalid length');
    }
    while (innerRemainder.length) {
      d = _decode(innerRemainder);
      decoded.push(d.data);
      innerRemainder = d.remainder;
    }
    return {
      data: decoded,
      remainder: input.slice(totalLength)
    };
  }
}
/** Check if a string is prefixed by 0x */
function isHexPrefixed(str) {
  return str.slice(0, 2) === '0x';
}
/** Removes 0x from a given String */
function stripHexPrefix(str) {
  if (typeof str !== 'string') {
    return str;
  }
  return isHexPrefixed(str) ? str.slice(2) : str;
}
/** Transform an integer into its hexadecimal value */
function intToHex(integer) {
  if (integer < 0) {
    throw new Error('Invalid integer as argument, must be unsigned!');
  }
  var hex = integer.toString(16);
  return hex.length % 2 ? "0" + hex : hex;
}
/** Pad a string to be even */
function padToEven(a) {
  return a.length % 2 ? "0" + a : a;
}
/** Transform an integer into a Buffer */
function intToBuffer(integer) {
  var hex = intToHex(integer);
  return Buffer.from(hex, 'hex');
}
/** Transform anything into a Buffer */
function toBuffer(v) {
  if (!Buffer.isBuffer(v)) {
    if (typeof v === 'string') {
      if (isHexPrefixed(v)) {
        return Buffer.from(padToEven(stripHexPrefix(v)), 'hex');
      } else {
        return Buffer.from(v);
      }
    } else if (typeof v === 'number' || typeof v === 'bigint') {
      if (!v) {
        return Buffer.from([]);
      } else {
        return intToBuffer(v);
      }
    } else if (v === null || v === undefined) {
      return Buffer.from([]);
    } else if (v instanceof Uint8Array) {
      return Buffer.from(v);
    } else if (bn_js_1["default"].isBN(v)) {
      // converts a BN to a Buffer
      return Buffer.from(v.toArray());
    } else {
      throw new Error('invalid type');
    }
  }
  return v;
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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